import { CalendarEventDetails, ExternalCalendarEvent } from '@griply/types';

import { sanitizeExternalUrl } from './sanitize-external-url';

export const sanitizeExternalCalendarEvent = (
  event: ExternalCalendarEvent,
): ExternalCalendarEvent => ({
  ...event,
  url: sanitizeExternalUrl(event.url),
});

export const sanitizeExternalCalendarEvents = (
  events: ExternalCalendarEvent[],
): ExternalCalendarEvent[] => events.map(sanitizeExternalCalendarEvent);

export const sanitizeCalendarEventDetails = (
  details: CalendarEventDetails,
): CalendarEventDetails => ({
  ...details,
  videoCallUrl: sanitizeExternalUrl(details.videoCallUrl) ?? null,
});
